export class ExcelValidationResult{
    isValid=true;
    errorMsg:string[]=[];
}